import { type DocumentNode, visit } from 'graphql';

export type UnusedVariableTransformerProps = {
  enabled?: boolean;
  onTransform?: (message: string) => void;
};

export class UnusedVariableTransformer {
  enabled: boolean;
  onTransform: UnusedVariableTransformerProps['onTransform'];

  constructor({ enabled = true, onTransform }: UnusedVariableTransformerProps = {}) {
    this.enabled = enabled;
    this.onTransform = onTransform;
  }

  transform(document: DocumentNode): DocumentNode {
    const usedVariables = new Set<string>();

    if (!this.enabled) {
      return document;
    }

    // read through document and get all used variables
    visit(document, {
      Argument: {
        enter: (node) => {
          if (node.value.kind === 'Variable') {
            usedVariables.add(node.value.name.value);
          }
        },
      },
    });

    // remove unused variables
    return visit(document, {
      OperationDefinition: {
        leave: (node) => {
          const usedVariablesDefinitions = [];
          const unusedVariableDefintionNames = [];

          for (const variable of node.variableDefinitions || []) {
            if (usedVariables.has(variable.variable.name.value)) {
              usedVariablesDefinitions.push(variable);
            } else {
              unusedVariableDefintionNames.push(variable.variable.name.value);
            }
          }

          if (unusedVariableDefintionNames.length) {
            this.onTransform?.(
              `Removing unused variables: ${unusedVariableDefintionNames.join(', ')}`,
            );
          }

          return {
            ...node,
            variableDefinitions: node.variableDefinitions?.filter((variable) =>
              usedVariables.has(variable.variable.name.value),
            ),
          };
        },
      },
    });
  }
}
